<template>
  <AccordionSection title="Delivery & Notifications" subtitle="Set your notification preference.">
    <div class="flex flex-col mt-4 gap-3">
      <div class="option-details flex !flex-row items-center">
        <p class="flex-1">In-App</p>
        <p class="flex-1 text-blueCrayola">Send  in-app notification when a new pay slip is generated.</p>
        <label class="switch" :class="{ 'disabled-switch': !canEdit }">
          <input
            type="checkbox"
            :checked="notificationSettings.inAppNotification"
            :disabled="!canEdit"
            @change="canEdit && updateNotification({ inAppNotification: $event.target.checked })"
          />
          <span class="slider round" :class="{ 'disabled-switch opacity-50': !canEdit }"></span>
        </label>
      </div>
      <div class="option-details flex !flex-row items-center">
        <p class="flex-1">Email</p>
        <p class="flex-1 text-blueCrayola">Send pay slip by email when  a new pay slip is generated.</p>

        <label class="switch" :class="{ 'disabled-switch': !canEdit }">
          <input
            type="checkbox"
            :checked="notificationSettings.emailNotification"
            :disabled="!canEdit"
            @change="canEdit && updateNotification({ emailNotification: $event.target.checked })"
          />
          <span class="slider round" :class="{ 'disabled-switch opacity-50': !canEdit }"></span>
        </label>
      </div>
    </div>
  </AccordionSection>
</template>

<script>
import AccordionSection from './PayPreferenceAccordion';

export default {
  components: {
    AccordionSection,
  },
  props: {
    notificationSettings: {
      type: Object,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateNotification(newSettings) {
      // Emit the updated settings to the parent component
      this.$emit('update', { ...this.notificationSettings, ...newSettings });
    },
  },
};
</script>

<style scoped>
.disabled-switch {
  cursor: not-allowed;
  opacity: 0.7;
}
</style>
